// @see inc/comp/ExportMediaLibrary.class.php
import React from "react";
import rmlOpts from "rmlopts";
import { Menu } from "react-aiot";
import { DashIcon } from "../components";
import { IS_DARKMODE, hooks, uri, addUrlParam, urlBuilder } from "../util";

if (+rmlOpts.others.massedge_wp_export) {
  const Item = Menu.Item,
        ItemGroup = Menu.ItemGroup,
        SUPPORTS_SUBFOLDERS = +rmlOpts.others.childrenSql > 1;
  /**
   * Handle click on a menu item so the correct admin page can be called.
   */

  const handleClick = function (e) {
    const url = uri(urlBuilder({
      location: {
        path: "/massedge/export"
      }
    })).query({
      type: e.key,
      folder: this.props.store.selectedId,
      _wpnonce: rmlOpts.restNonce
    }).build();
    window.location.href = url;
  };
  /**
   * A function which is called to render the dropdown menu.
   */


  const renderMenu = function () {
    const store = this.props.store,
          selected = store.selected,
          isFolder = selected && (selected.id > 0 || selected.id === -1);

    if (!isFolder) {
      return /*#__PURE__*/React.createElement(Menu, {
        style: {
          visibility: "hidden"
        }
      });
    }

    return /*#__PURE__*/React.createElement(Menu, {
      onClick: handleClick.bind(this),
      theme: IS_DARKMODE ? "dark" : "light"
    }, /*#__PURE__*/React.createElement(ItemGroup, {
      key: "wos",
      title: "Without RML subfolders"
    }, /*#__PURE__*/React.createElement(Item, {
      key: "wosFlat"
    }, "As flat .zip file"), /*#__PURE__*/React.createElement(Item, {
      key: "wosHierarchical"
    }, "As hierarchical .zip file (physical structure)")), selected.id !== -1 && /*#__PURE__*/React.createElement(ItemGroup, {
      key: "ws",
      title: "Include RML subfolders" + (SUPPORTS_SUBFOLDERS ? "" : " (not supported by your system)")
    }, /*#__PURE__*/React.createElement(Item, {
      key: "wsFlat",
      disabled: !SUPPORTS_SUBFOLDERS
    }, "As flat .zip file"), /*#__PURE__*/React.createElement(Item, {
      key: "wsHierarchicalRML",
      disabled: !SUPPORTS_SUBFOLDERS
    }, "As hierarchical .zip file (RML structure)"), /*#__PURE__*/React.createElement(Item, {
      key: "wsHierarchical",
      disabled: !SUPPORTS_SUBFOLDERS
    }, "As hierarchical .zip file (physical structure)")));
  }; // Create download icon and register it to the toolbar


  hooks.register("tree/init", function () {
    this.stateRefs.ICON_DOWNLOAD_ZIP = /*#__PURE__*/React.createElement(DashIcon, {
      name: "download"
    });
    this.stateRefs.renderDownloadZipMenu = renderMenu.bind(this); // When clicking on the download icon in "All" or "Unorganized" redirect to usual export page

    this.stateRefs.handleDownloadZipClick = function () {
      const selectedId = this.props.store.selectedId;

      if (selectedId === "all" || this.props.store.selectedId === -1) {
        window.location.href = addUrlParam(window.location.href, "page", "mass-edge-export-media-library");
      }
    }.bind(this);

    this.state.toolbar_download_zip = {
      content: "ICON_DOWNLOAD_ZIP",
      toolTipTitle: "Download folder as zip",
      toolTipText: "A folder can be downloaded as flat or hierarchical zip.",
      menu: "resolve.renderDownloadZipMenu",
      toolTipPlacement: "topLeft",
      dropdownPlacement: "bottomLeft",
      onClick: "handleDownloadZipClick"
    };
    this.state.availableToolbarButtons.unshift("download_zip");
  });
}